export default __webpack_public_path__ + "static/media/UTPL-Financial-Statements-March-2025.e517c6e1.pdf";